import Skeleton from '@/components/ui/Skeleton'

/** Five cards in `NewsStoryCard`'s box: headline, two summary lines, the meta line. */
export const FEED_SKELETON = (
  <div className="flex flex-col gap-4">
    <Skeleton className="h-4 w-12 rounded-xs" />
    <div className="flex flex-col gap-3">
      {Array.from({ length: 5 }, (_, index) => (
        <div key={index} className="flex flex-col gap-2 bg-card px-5 py-4">
          <Skeleton className="h-5 w-2/5 rounded-xs" />
          <Skeleton className="h-4 w-4/5 rounded-xs" />
          <Skeleton className="h-3 w-40 rounded-xs" />
        </div>
      ))}
    </div>
  </div>
)

/** Five of `NewsArticleCard`'s box, thumb included (mock `.nw-skel`). */
export const STORIES_SKELETON = (
  <div className="flex flex-col gap-3">
    {Array.from({ length: 5 }, (_, index) => (
      <div key={index} className="flex items-start gap-5 bg-card px-5 py-4">
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <Skeleton className="h-5 w-40 rounded-xs" />
          <Skeleton className="h-4 w-4/5 rounded-xs" />
          <Skeleton className="h-4 w-3/5 rounded-xs" />
          <Skeleton className="h-3 w-full rounded-xs" />
        </div>
        <Skeleton className="h-17 w-22 shrink-0 lg:h-26 lg:w-34" />
      </div>
    ))}
  </div>
)
